import { Box, Container, Typography } from '@mui/material';
import React from 'react';
import stateBg from '../../../../images/Group 1.png';
import rightBg from '../../../../images/Vector 68.png';
import PortfolioSlider from '../PortfolioSlider/PortfolioSlider';
const stateTextBg = {
    backgroundImage: `url(${stateBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    paddingLeft: '2%'
}
const portfolioBg = {
    backgroundImage: `url(${rightBg})`,
    backgroundPosition: 'right bottom 2%',
    backgroundRepeat: 'no-repeat'
}

const Portfolio = () => {
    return (
        <div id="portfolio-bg">
            <Box id="portfolio-bg-sm">
                <Box style={portfolioBg}>
                    <Container>
                        <Box style={stateTextBg} sx={{ textAlign: 'left' }}>
                            <Typography variant="h6" id="stats-start" sx={{ color: '#0015D1', textDecoration: 'underline', fontWeight: 600, fontSize: '35px', pt: '2%' }}>
                                Portfolio
                            </Typography>
                            <Typography variant="h3" id="stats-title" sx={{ pt: 1, pb: 3, color: '#000D83', fontWeight: 600 }}>
                                Our Recent Work
                            </Typography>
                        </Box>
                    </Container>
                    <PortfolioSlider />
                </Box>
            </Box>
        </div>
    );
};

export default Portfolio;